import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';
import { unorderedListType } from './listType';

const baseMargin = 3;
const fontSizes = {
  h1: {
    fontSize: '24px',
    marginLeft: (isUnorderedList: boolean) => (isUnorderedList ? 2 : 10),
  },
  h2: {
    fontSize: '20px',
    marginLeft: (isUnorderedList: boolean) => (isUnorderedList ? -1 : 6),
  },
  h3: {
    fontSize: '16px',
    marginLeft: (isUnorderedList: boolean) => (isUnorderedList ? -2 : 2),
  },
};

export const Ol = styled.ol`
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  margin-top: 0;
  margin-bottom: 0;
`;

export const Ul = styled.ul`
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  margin-top: 0;
  margin-bottom: 0;

  li {
    margin-left: -${baseMargin}px;
  }
`;

export const headingStyles = (type: unknown, parentType: unknown) => {
  const headingType = type as keyof typeof fontSizes;

  if (!fontSizes[headingType]) {
    return '';
  }

  const { fontSize, marginLeft } = fontSizes[headingType];

  return `
    line-height: 1.3em;
    font-weight: ${theme.font.weight.semiBold};
    font-size: ${fontSize};
    margin-left: ${marginLeft(parentType === unorderedListType)}px;
  `;
};

export const Li = styled.li<{ type: unknown; parentType: unknown }>`
  p {
    margin-top: ${theme.spacing.xSmall};
    margin-bottom: ${theme.spacing.xSmall};
  }

  ${({ type, parentType }) => headingStyles(type, parentType)}};
`;
